import React, { Component } from 'react';
import ScreenContainer from '../../ui/ScreenContainer';
import EditGrid from '../../ui/EditGrid/EditGrid';
import * as apiDashBoardService from './apiRequestService';
import * as Actions from '../../../redux/actions';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';
import {styleForHeader} from '../../../style.js';


class CompanyMail extends Component {
    constructor(props) {
      super(props);
      this.state = {
        gridFunc:null,
        gridColumns : [
            { field: 'id', hide: true},
            { field: 'emailAddress', width: 400, headerAlign:'left', align:'left', text:'E-posta',
                renderHeader: () => styleForHeader('E-posta')
            }
        ],
        CRUDServices:{
          Create:apiDashBoardService.createMailAddress,
          Update:apiDashBoardService.updateMailAddress,
          Delete:apiDashBoardService.deleteMailAddress}
      };
    }
    refreshList(){
      apiDashBoardService.getAllMailAddress()
      .then((response) => {
        this.gridFunc.state.gridRows= response.data;
        this.gridFunc.state.gridColumns= this.state.gridColumns;
        this.gridFunc.state.columnVisibilityModel= {id:false};
    
        this.gridFunc.setState(this.gridFunc.state)
      })
      .catch((exception) => {
        this.props.actions.setNotification("Firma mail adres bilgileri getirilemedi daha sonra tekrar deneyin.", 'error');
        console.log('getAllMailAddress exception: ' + JSON.stringify(exception));
      });      
    }
    componentDidMount() {
      this.refreshList();
    }
  
    closeEditPage(ele) {
      this.refreshList();
    }
    
    render() {
      const { CRUDServices } = this.state;

      return (
        <div>
          <div style = {{display: 'flex',
            flexDirection: 'column'}}>
            <ScreenContainer>
              <EditGrid ref={instance => { this.gridFunc = instance; }} dialogTitle="Firma E-Posta Tanımı" gridHeight={400} {...this.props} CRUD={CRUDServices} 
              LoadData={(e) => this.closeEditPage(e)}/>
            </ScreenContainer>     
          </div>
        </div>
      );
    }
  }

  const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(Actions, dispatch)
  });

  export default compose(
    connect(
      null,
      mapDispatchToProps
    )
  )(CompanyMail);